export default {
  MISSING: 'MISSING',
  VERIFIED_OK: 'VERIFIED_OK',
  UNVERIFIED: 'UNVERIFIED',
  EXPIRED: 'EXPIRED',
};
